<template>
  <button :class="['base-button', 'theme-' + theme, loading && 'loading', reverse && 'reverse']">
    <div class="content">
      <div class="text" v-if="text">{{ text }}</div>
      <img class="icon" :src="icon" :style="{ height: iconHeight }" v-if="icon" />
    </div>
    <div class="spinner">
      <BaseSpinner :theme="spinnerTheme" />
    </div>
  </button>
</template>

<script>
import BaseSpinner from '@/components/BaseSpinner/BaseSpinner'
export default {
  components: {
    BaseSpinner
  },
  props: {
    text: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    reverse: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'purple'
    },
    spinnerTheme: {
      type: String,
      default: 'light'
    },
    iconHeight: {
      type: String,
      default: '1.5rem'
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.base-button {
  position: relative;
  border-radius: var(--br-1);
  border: var(--border-1);
  transition: all 0.2s;
  cursor: pointer;
}
.content {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 1rem;
  height: 3.2rem;
  padding: 0 var(--spacing-2);
  justify-content: center;
  align-items: center;
  font-weight: var(--fw-medium);
  font-size: 1.4rem;
}
.loading .content {
  visibility: hidden;
}
.reverse .text {
  grid-column: 2;
}
.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  visibility: hidden;
}
.loading .spinner {
  visibility: visible;
}
.loading {
  pointer-events: none;
  cursor: default;
}
.theme-white {
  color: var(--color-gray-3);
  background: var(--color-white-1);
}
.theme-red {
  color: var(--color-white-1);
  background: var(--color-red-1);
  border-color: var(--color-transparent);
}
.theme-purple {
  color: var(--color-white-1);
  background: var(--color-purple-1);
  border-color: var(--color-transparent);
}
.theme-gray {
  color: var(--color-gray-3);
  background: var(--color-gray-2);
}
.theme-disabled {
  color: var(--color-gray-5);
  background: var(--color-gray-1);
  pointer-events: none;
  cursor: default;
}
</style>
